'use client'

import React, { useContext, useRef } from 'react'
import classNames from 'classnames'

import { ConditionalWrapper, Popover } from '@/components'
import { useLanguages, useOnClickOutside } from '@/hooks'
import { Link } from '@/i18n'

import { HeaderContext } from '../context'

import { menuPaths } from './constants'
import { Languages } from './language'
import { Currency } from './currency'

export const HeaderMenu: React.FC = () => {
  const { t } = useLanguages()
  const divRef = useRef<HTMLDivElement>(null)
  const {
    isActive,
    onToggleMenu,
    onClose: _onClose,
  } = useContext(HeaderContext)

  useOnClickOutside(divRef, isActive, onToggleMenu)

  return (
    <div
      ref={divRef}
      className={classNames('menu_wrapper', {
        active: isActive,
      })}
    >
      <nav className="header_menu">
        <ul className="flex-container align-middle">
          <React.Fragment>
            {menuPaths.map((path, idx) => (
              <Popover
                key={idx}
                WrapEl="li"
                disabled={!path.subPaths?.length}
                button={
                  <ConditionalWrapper
                    // @ts-ignore
                    href={path.path}
                    WrapEl={path.path ? 'a' : 'p'}
                  >
                    {t(path.title)}
                  </ConditionalWrapper>
                }
              >
                {!!path.subPaths?.length &&
                  (onClose => (
                    <ul>
                      {path.subPaths?.map((subPath, _idx) => (
                        <li key={_idx}>
                          <Link
                            href={subPath.path}
                            onClick={_onClose(onClose)}
                            target={subPath.isExternal ? '_blank' : '_self'}
                          >
                            {t(subPath.title)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  ))}
              </Popover>
            ))}
          </React.Fragment>
        </ul>
      </nav>
      <div className="header_right hide-for-desktop">
        <nav>
          <ul className="flex-container">
            <Currency />
            <Languages />
          </ul>
        </nav>
      </div>
    </div>
  )
}
